module.exports = __webpack_public_path__ + "assets/img/simple_index_html_body_tag.98f6d7b1.jpg";